/**
 * The scroll area thumb's height.
 * @type {number}
 */
export const scrollAreaThumbHeight = '--scroll-area-thumb-height';
/**
 * The scroll area thumb's width.
 * @type {number}
 */
export const scrollAreaThumbWidth = '--scroll-area-thumb-width';
